/**
 * Promos Module API Endpoints - Single Source of Truth
 * 
 * ⭐ CENTRALIZED ENDPOINTS - All Promos module API endpoints
 * - Campaigns endpoints
 * - Promos endpoints (to be added later)
 * - Analytics endpoints (future)
 * - Audit logs endpoints (future)
 */

export const PROMOS_ENDPOINTS = {
  CAMPAIGNS: {
    LIST_ALL: '/api/v1/promo/campaigns/list/all',
    CREATE: '/api/v1/promo/campaigns',
    GET_BY_ID: '/api/v1/promo/campaigns/{id}',
    UPDATE: '/api/v1/promo/campaigns/{id}/update',
    UPDATE_STATUS: '/api/v1/promo/campaigns/{id}/update-status',
    DELETE: '/api/v1/promo/campaigns/{id}',
    ACTIVATE: '/api/v1/promo/campaigns/{id}/activate',
    DEACTIVATE: '/api/v1/promo/campaigns/{id}/deactivate',
  },
  
  // Promo Codes endpoints
  PROMOS: {
    LIST: '/api/v1/promo',
    CREATE: '/api/v1/promo',
    GET_BY_ID: '/api/v1/promo/{id}',
    UPDATE: '/api/v1/promo/{id}/update',
    UPDATE_STATUS: '/api/v1/promo/{id}/update-status',
    DELETE: '/api/v1/promo/{id}/delete',
  },
  
  // Future: Analytics endpoints
  ANALYTICS: {
    CAMPAIGN_STATS: '/api/v1/promo/analytics/campaigns',
    PROMO_USAGE: '/api/v1/promo/analytics/usage',
    REVENUE_IMPACT: '/api/v1/promo/analytics/revenue',
  },
  
  // Audit logs endpoints
  AUDIT_LOGS: {
    LIST: '/api/v1/promo/audit-logs/list',
    EXPORT: '/api/v1/promo/audit/export',
  },
  
  // Usage endpoints
  USAGE: {
    LIST: '/api/v1/promo/usages/list',
  }
} as const;
